<template>
  <div class="wrapper-answer-section border border-secondary-20 rounded-lg px-6 py-7">
    <div
      class="answers-and-submissions flex flex-col gap-5"
      ref="answerRef"
    >
      <QuestionContent
        :result="dataAnswer"
        :order="order"
        :totalQuiz="totalQuiz"
      />
      <component
        :is="answerComponentMap[slideType]"
        :dataAnswer="dataAnswer"
      />
    </div>
  </div>
</template>

<script>
import QuestionContent from '@/components-v2/presentation-report/ReportAudienceDetail/QuestionContent.vue'
import TwoColumnQuizReview from '@/components-v2/presentation-report/ReportAudienceDetail/closed-question/TwoColumnQuizReview.vue'
import ShortAnswer from '@/components-v2/presentation-report/ReportAudienceDetail/closed-question/ShortAnswer.vue'
import CorrectOrder from '@/components-v2/presentation-report/ReportAudienceDetail/closed-question/CorrectOrder.vue'
import MatchPair from '@/components-v2/presentation-report/ReportAudienceDetail/closed-question/MatchPair.vue'
import ListSubmission from '@/components-v2/presentation-report/ReportAudienceDetail/open-question/ListSubmission.vue'
import BlockSubmission from '@/components-v2/presentation-report/ReportAudienceDetail/open-question/BlockSubmission.vue'

export default {
  components: {
    QuestionContent,
    TwoColumnQuizReview,
    ShortAnswer,
    CorrectOrder,
    MatchPair,
    ListSubmission,
    BlockSubmission,
  },
  props: {
    dataAnswer: {
      type: Object,
      default: () => {},
    },
    order: {
      type: Number,
      default: 1,
    },
    totalQuiz: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    answerComponentMap() {
      return {
        correctOrder: 'CorrectOrder',
        pickAnswer: 'TwoColumnQuizReview',
        imageChoice: 'TwoColumnQuizReview',
        typeAnswer: 'ShortAnswer',
        matchPairs: 'MatchPair',
        'Word Cloud': 'ListSubmission',
        'Open Ended': 'BlockSubmission',
        Brainstorm: 'BlockSubmission',
      }
    },
    slideType() {
      return this.dataAnswer.slideDetails?.slideType || 'pickAnswer'
    },
  },
}
</script>

<style lang="scss" scoped>
.answers-and-submissions {
  color: var(--base-90, #313131);
}
</style>
